import apiFetch from '../../apiFetch'

export default function (dossierId, dossierDetails, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/purchase/${dossierId}`, method: 'PUT', body: dossierDetails, token: token, lastAccessDate })
}
